import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { PartnerStatus } from 'clickNgo/entities/partner/configs'
import { TPartnerStatus } from 'clickNgo/entities/partner/models'
import { PARTNER_STATUS_ENDPOINT } from 'onboarding/api/partnerStatusApi'
import { callJSend } from 'shared/lib/http/callJSend'

interface IChangePartnerStatusParams {
  locationId: string
  status: TPartnerStatus
  source: ProfilingRequestSource
}

interface IChangePartnerStatusResponse {
  partnerStatus: PartnerStatus
  messages?: string[]
}

export const changePartnerStatus = async ({
  locationId,
  status,
  source,
}: IChangePartnerStatusParams) =>
  callJSend<IChangePartnerStatusResponse>({
    method: 'post',
    url: PARTNER_STATUS_ENDPOINT,
    payload: { locationId, status, source },
  })
